<template>
    <div>
        <item-despesa
            :item="item"
        >
            <template slot="footer">
                <app-btn-voltar
                    rota="DespesasGerais_Financeiro_Despesas_Detalhar"
                ></app-btn-voltar>
            </template>
        </item-despesa>
        <router-view></router-view>
    </div>
</template>

<script>
import ItemDespesa from '@/app/despesasgerais/componentes/itensDespesas/ItemDespesa.vue'
import ItensDespesasServicos from './ItensDespesasServicos'

export default {
    data() {
        return {
            item: {}
        }
    },
    
    components: {
        ItemDespesa
    },

    methods: {
        obterItem() {
            if (this.$route.params.itemDespesa != null){
                this.item = this.$route.params.itemDespesa
            } else {
                this.$store.dispatch('addRequest')
                ItensDespesasServicos.obterPorId(this.$route.params.despesaItemId).then(response => {
                    if (response) {
                        if (response.success) {
                            this.item = response.data
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        }
    },

    created() {
        this.obterItem()
    }
}

</script>